// extracted by mini-css-extract-plugin
module.exports = {"planRecommenderLayout":"planRecommenderLayout_planRecommenderLayout__3I-Ry","content":"planRecommenderLayout_content__1UKfM"};